import IntervalTimer from './intervalTimer'
import XgplayerTimeRange from './xgplayerTimeRange'

let util = {}

util.createDom = function (el = 'div', tpl = '', attrs = {}, cname = '') {
  let dom = document.createElement(el)
  dom.className = cname
  dom.innerHTML = tpl
  Object.keys(attrs).forEach(item => {
    let key = item
    let value = attrs[item]
    if (el === 'video' || el === 'audio') {
      if (value) {
        dom.setAttribute(key, value)
      }
    } else {
      dom.setAttribute(key, value)
    }
  })
  return dom
}

util.hasClass = function (el, className) {
  if (!el) return null
  if (el.classList) {
    return Array.prototype.some.call(el.classList, item => item === className)
  } else {
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
  }
}

util.addClass = function (el, className) {
  if (!el) return null
  if (el.classList) {
    className.replace(/(^\s+|\s+$)/g, '').split(/\s+/g).forEach(item => {
      item && el.classList.add(item)
    })
  } else if (!util.hasClass(el, className)) {
    el.className += ' ' + className
  }
}

util.removeClass = function (el, className) {
  if (!el) return null
  if (el.classList) {
    className.split(/\s+/g).forEach(item => {
      el.classList.remove(item)
    })
  } else if (util.hasClass(el, className)) {
    className.split(/\s+/g).forEach(item => {
      let reg = new RegExp('(\\s|^)' + item + '(\\s|$)')
      el.className = el.className.replace(reg, ' ')
    })
  }
}

util.toggleClass = function (el, className) {
  if (!el) return null
  className.split(/\s+/g).forEach(item => {
    if (util.hasClass(el, item)) {
      util.removeClass(el, item)
    } else {
      util.addClass(el, item)
    }
  })
}

util.findDom = function (el = document, sel) {
  let dom
  // fix querySelector IDs that start with a digit
  // https://stackoverflow.com/questions/37270787/uncaught-syntaxerror-failed-to-execute-queryselector-on-document
  try {
    dom = el.querySelector(sel)
  } catch (e) {
    if (sel.startsWith('#')) {
      dom = el.getElementById(sel.slice(1))
    }
  }
  return dom
}

util.padStart = function (str, length, pad) {
  let charstr = String(pad)
  let len = length >> 0
  let maxlen = Math.ceil(len / charstr.length)
  let chars = []
  let r = String(str)
  while (maxlen--) {
    chars.push(charstr)
  }
  return chars.join('').substring(0, len - r.length) + r
}

util.format = function (time) {
  if (window.isNaN(time)) {
    return ''
  }
  let hour = util.padStart(Math.floor(time / 3600), 2, 0)
  let minute = util.padStart(Math.floor((time - hour * 3600) / 60), 2, 0)
  let second = util.padStart(Math.floor((time - hour * 3600 - minute * 60)), 2, 0)
  return (hour === '00' ? [minute, second] : [hour, minute, second]).join(':')
}

util.event = function (e) {
  if (e.touches) {
    let touch = e.touches[0] || e.changedTouches[0]
    e.clientX = touch.clientX || 0
    e.clientY = touch.clientY || 0
    e.offsetX = touch.pageX - touch.target.offsetLeft
    e.offsetY = touch.pageY - touch.target.offsetTop
  }
  e._target = e.target || e.srcElement
}

util.typeOf = function (obj) {
  return Object.prototype.toString.call(obj).match(/([^\s.*]+)(?=]$)/g)[0]
}

util.deepCopy = function (dst, src) {
  if (util.typeOf(src) === 'Object' && util.typeOf(dst) === 'Object') {
    Object.keys(src).forEach(key => {
      if (util.typeOf(src[key]) === 'Object' && !(src[key] instanceof Node)) {
        if (!dst[key]) {
          dst[key] = src[key]
        } else {
          util.deepCopy(dst[key], src[key])
        }
      } else if (util.typeOf(src[key]) === 'Array') {
        dst[key] = util.typeOf(dst[key]) === 'Array' ? dst[key].concat(src[key]) : src[key]
      } else {
        dst[key] = src[key]
      }
    })
    return dst
  }
}
util.getBgImage = function (el) {
  // fix: return current page url when url is none
  let url = (el.currentStyle || window.getComputedStyle(el, null)).backgroundImage
  if (!url || url === 'none') {
    return ''
  }
  let a = document.createElement('a')
  a.href = url.replace(/url\("|"\)/g, '')
  return a.href
}

util.copyDom = function (dom) {
  if (dom && dom.nodeType === 1) {
    let back = document.createElement(dom.tagName)
    Array.prototype.forEach.call(dom.attributes, (node) => {
      back.setAttribute(node.name, node.value)
    })
    if (dom.innerHTML) {
      back.innerHTML = dom.innerHTML
    }
    return back
  } else {
    return ''
  }
}

util.setInterval = function (context, eventName, intervalFunc, frequency) {
  if (!context._interval[eventName]) {
    context._interval[eventName] = setInterval(intervalFunc.bind(context), frequency)
  }
}

util.clearInterval = function (context, eventName) {
  clearInterval(context._interval[eventName])
  context._interval[eventName] = null
}

util.createImgBtn = function (name, imgUrl, width, height) {
  let btn = util.createDom(`xg-${name}`, '', {}, `xgplayer-${name}-img`)
  btn.style.backgroundImage = `url("${imgUrl}")`
  if (width && height) {
    let w, h, unit
    ['px', 'rem', 'em', 'pt', 'dp', 'vw', 'vh', 'vm', '%'].every((item) => {
      if (width.indexOf(item) > -1 && height.indexOf(item) > -1) {
        w = parseFloat(width.slice(0, width.indexOf(item)).trim())
        h = parseFloat(height.slice(0, height.indexOf(item)).trim())
        unit = item
        return false
      } else {
        return true
      }
    })
    btn.style.width = `${w}${unit}`
    btn.style.height = `${h}${unit}`
    btn.style.backgroundSize = `${w}${unit} ${h}${unit}`
    if (name === 'start') {
      btn.style.margin = `-${h / 2}${unit} auto auto -${w / 2}${unit}`
    } else {
      btn.style.margin = 'auto 5px auto 5px'
    }
  }
  return btn
}

util.Hex2RGBA = function (hex, alpha) {
  let rgb = [] // 定义rgb数组
  if (/^\#[0-9A-F]{3}$/i.test(hex)) {
    let sixHex = '#'
    hex.replace(/[0-9A-F]/ig, function (kw) {
      sixHex += kw + kw
    })
    hex = sixHex
  }
  if (/^#[0-9A-F]{6}$/i.test(hex)) {
    hex.replace(/[0-9A-F]{2}/ig, function (kw) {
      rgb.push(eval('0x' + kw))
    })
    return `rgba(${rgb.join(',')}, ${alpha})`
  } else {
    return 'rgba(255, 255, 255, 0.1)'
  }
}

util.isSupportMP4 = function () {
  const RegExp = [{
    key: 'Trident',
    reg: /(rv:)([\d.]+)/
  },
  {
    key: 'Trident',
    reg: /(msie)\s*([\d.]+)/
  }, {
    key: 'Chrome',
    reg: /(chrome)\/([\d.]+)/
  }]
  const ua = navigator.userAgent.toLowerCase()
  let match = null
  const browser = {}
  for (const key in RegExp) {
    match = RegExp[key].reg.exec(ua)
    if (match) {
      const name = RegExp[key].key
      browser[`is${name}`] = name
      browser.name = name
      browser.appVersion = match.length > 2 ? match[2] : ''
      break
    }
  }

  if (!(browser.isChrome && (browser.appVersion === '77.0.3835.0' || browser.appVersion === '76.0.3790.0')) && !browser.isTrident) {
    return true
  }
  const H264_MIMETYPES = [
    'avc1.42E01E, mp4a.40.2',
    'avc1.58A01E, mp4a.40.2',
    'avc1.4D401E, mp4a.40.2',
    'avc1.64001E, mp4a.40.2',
    'avc1.42E01E',
    'mp4v.20.8',
    'mp4v.20.240',
    'avc1.42E01E, mp4a.40.2',
    'avc1.58A01E, mp4a.40.2',
    'avc1.4D401E, mp4a.40.2',
    'avc1.64001E, mp4a.40.2',
    'mp4v.20.8, mp4a.40.2',
    'mp4v.20.240, mp4a.40.2'
  ]
  let a = document.createElement('video')
  let result = {
    isSupport: false,
    mime: ''
  }
  if (typeof a.canPlayType === 'function') {
    H264_MIMETYPES.map(key => {
      if (a.canPlayType(`video/mp4; codecs="${key}"`) === 'probably') {
        result.isSupport = true
        result.mime += `||${key}`
      }
    })
    return result.isSupport
  }
  a = null
  return result.isSupport
}

util.calcFrameRate = function (player) {
  if (!player || !player.video || player.video.webkitDecodedFrameCount === undefined || player.video.webkitDroppedFrameCount === undefined) return false

  let frameRateInterval = player.config.frameRateInterval || 1000

  player.currentFrameRate = 0
  player.currentDecodedFrameCount = 0

  if (player.frameRateTimer) {
    player.frameRateTimer.clear()
    player.frameRateTimer = null
  }

  player.frameRateTimer = new IntervalTimer()
  player.frameRateTimer.repeat(() => {
    player.currentFrameRate = (player.video.webkitDecodedFrameCount - player.currentDecodedFrameCount) / frameRateInterval * 1000
    player.currentDecodedFrameCount = player.video.webkitDecodedFrameCount
    player.currentDroppedFrameCount = player.video.webkitDroppedFrameCount
  }, frameRateInterval)

  function destroyFunc () {
    if (player.frameRateTimer) {
      player.frameRateTimer.clear()
      player.frameRateTimer = null
    }
    player.off('destroy', destroyFunc)
  }
  player.once('destroy', destroyFunc)

  return true
}

util.offInDestroy = (object, event, fn, offEvent) => {
  function onDestroy () {
    object.off(event, fn)
    object.off(offEvent, onDestroy)
  }
  object.once(offEvent, onDestroy)
}

util.on = (object, event, fn, offEvent) => {
  if (offEvent) {
    object.on(event, fn)
    util.offInDestroy(object, event, fn, offEvent)
  } else {
    let _fn = data => {
      fn(data)
      object.off(event, _fn)
    }
    object.on(event, _fn)
  }
}

util.once = (object, event, fn, offEvent) => {
  if (offEvent) {
    object.once(event, fn)
    util.offInDestroy(object, event, fn, offEvent)
  } else {
    let _fn = data => {
      fn(data)
      object.off(event, _fn)
    }
    object.once(event, _fn)
  }
}

util.getBuffered2 = (vbuffered, maxHoleDuration = 0.5) => { //ref: hls.js
  let buffered = []
  for (let i = 0; i < vbuffered.length; i++) {
    buffered.push({ start: vbuffered.start(i), end: vbuffered.end(i) });
  }
  buffered.sort(function (a, b) {
    let diff = a.start - b.start;
    if (diff) {
      return diff;
    } else {
      return b.end - a.end;
    }
  });
  let buffered_2 = []
  if (maxHoleDuration) {
    for (let i = 0; i < buffered.length; i++) {
      let buf2len = buffered_2.length
      if (buf2len) {
        let buf2end = buffered_2[buf2len - 1].end
        if ((buffered[i].start - buf2end) < maxHoleDuration) {
          if (buffered[i].end > buf2end) {
            buffered_2[buf2len - 1].end = buffered[i].end
          }
        } else {
          buffered_2.push(buffered[i])
        }
      } else {
        buffered_2.push(buffered[i])
      }
    }
  } else {
    buffered_2 = buffered
  }
  return new XgplayerTimeRange(buffered_2)
}

export default util
